import { FC, useCallback, useMemo, useState } from 'react'
import styles from 'components/features/rewards/rewardPage/LifetimeEarningsChart/LifetimeEarningsChart.styl'
import { ChartLineArea } from 'components/atoms/chart/ChartLineArea/ChartLineArea'
import { generate } from 'randomstring'
import { CryptoChart } from 'components/features/rewards/rewardPage/store'
import { ChartHighlight } from 'components/atoms/chart/ChartHighlight/ChartHighlight'
import { useCryptoChartContext } from 'components/features/rewards/rewardPage/useCryptoChartContext'
import { CryptoChartPreset } from 'components/features/rewards/rewardPage/CryptoChartPreset/CryptoChartPreset'
import { ChartLine } from 'components/atoms/chart/ChartLine/ChartLine'

const usdColor = '#95cd85'

type LifetimeEarningsChartProps = {
  data: CryptoChart
  onHover: (index: number) => void
}
export const LifetimeEarningsChart: FC<LifetimeEarningsChartProps> = (props) => {
  const { data, onHover } = props

  const cashGradId = useMemo(generate, [])
  const gradChild = useMemo(() => (
    <>
      <linearGradient id={ cashGradId } x1='0' y1='0' x2='0' y2='1' spreadMethod='pad'>
        <stop offset='0%' stopColor={ usdColor } />
        <stop offset='100%' stopColor={ usdColor } />
      </linearGradient>
    </>
  ), [cashGradId])


  const [hoverIndex, setHoverIndex] = useState(-1)
  const handleHover = useCallback((index: number) => {
    setHoverIndex(index)
    onHover(index)
  }, [onHover])

  const [size, setSize] = useState({ width: 0, height: 0 })
  const chartContexts = useCryptoChartContext(data, size)
  const { chartContext, usdLineContext, cryptoLineContext } = chartContexts

  const lineChild = useMemo(() => {
    return (
      <>
        <ChartLine
          context={ cryptoLineContext }
          className={ styles.cryptoLine }
        />
      </>
    )
  }, [cryptoLineContext])

  const areaChild = useMemo(() => {
    return (
      <>
        <ChartLineArea
          context={ usdLineContext }
          className={ styles.cashArea }
          style={{
            fill: `url(#${ cashGradId })`,
          }}
        />
      </>
    )
  }, [cashGradId, usdLineContext])

  return (
    <CryptoChartPreset
      contexts={ chartContexts }
      onHover={ handleHover }
      onSize={ setSize }
    >
      <defs>
        { gradChild }
      </defs>

      { areaChild }
      { lineChild }
      { hoverIndex !== -1 && (
        <ChartHighlight context={ chartContext } index={ hoverIndex } height={ size.height } />
      )}
    </CryptoChartPreset>
  )
}
